import React from 'react';

import {SECTION_MEDIA_SETTINGS_DESCRIPTION} from '../constants';
import {MediaSettingsDrawerContent} from './MediaSettingsDrawerContent';
import {
  MediaSettingsDrawerContextProvider,
  useSectionMediaSettingsDrawer,
} from './MediaSettingsDrawerContextProvider';
import {SettingsLevel} from './types';

export const SectionMediaSettingsDrawer = ({
  header,
}: {
  header: React.ReactNode;
}) => {
  const contextValue = useSectionMediaSettingsDrawer();
  return (
    <MediaSettingsDrawerContextProvider contextValue={contextValue}>
      <MediaSettingsDrawerContent
        header={header}
        description={SECTION_MEDIA_SETTINGS_DESCRIPTION}
        settingsLevel={SettingsLevel.SECTION}
      />
    </MediaSettingsDrawerContextProvider>
  );
};
